import { gql } from '@apollo/client';

export const CODE_GROUPS = gql`
  query codeGroups {
    codeGroups {
      id
      versionId
      value
      type
      groupedValues
      version
      versionLabel
      updatedAt
      updatedBy
      locales {
        language
        title
      }
    }
  }
`;

export const CODE_GROUP_VERSIONS = gql`
  query codeGroupVersions($id: ID!) {
    codeGroupVersions(id: $id) {
      id
      versionId
      version
      versionLabel
      updatedAt
      updatedBy
    }
  }
`;

export const CODE_GROUP = gql`
  query codeGroup($id: ID!, $version: String) {
    codeGroup(id: $id, version: $version) {
      id
      versionId
      value
      type
      groupedValues
      version
      versionLabel
      createdAt
      createdBy
      updatedAt
      updatedBy
      locales {
        language
        title
      }
    }
  }
`;

export const CREATE_CODE_GROUP = gql`
  mutation createCodeGroup($codeGroup: CodeGroupInput!) {
    createCodeGroup(codeGroup: $codeGroup) {
      id
      value
      type
      groupedValues
      version
      versionLabel
      updatedAt
      updatedBy
      locales {
        language
        title
      }
    }
  }
`;

export const UPDATE_CODE_GROUP = gql`
  mutation updateCodeGroup($id: ID!, $codeGroup: CodeGroupInput!, $expectedVersion: Int) {
    updateCodeGroup(id: $id, codeGroup: $codeGroup, expectedVersion: $expectedVersion) {
      id
      versionId
      value
      type
      groupedValues
      version
      versionLabel
      updatedAt
      updatedBy
      locales {
        language
        title
      }
    }
  }
`;

export const DELETE_CODE_GROUP = gql`
  mutation deleteCodeGroup($id: ID!) {
    deleteCodeGroup(id: $id) {
      success
    }
  }
`;
